export const districts = {
  2607: {
    data_id: 2607,
    name_uz: "Sirg'ali tumani",
    city_id: 12,
  },
  2710: {
    data_id: 2710,
    name_uz: 'Piskent tumani',
    city_id: 11,
  },
  1018: {
    data_id: 1018,
    name_uz: "Ko'kdala tumani",
    city_id: 4,
  },
  1814: {
    data_id: 1814,
    name_uz: 'Qo‘shrabot tumani',
    city_id: 8,
  },
  1821: {
    data_id: 1821,
    name_uz: 'Nurobod tumani',
    city_id: 8,
  },
  1817: {
    data_id: 1817,
    name_uz: 'Payariq tumani',
    city_id: 8,
  },
  1818: {
    data_id: 1818,
    name_uz: 'Pastdarg‘om tumani',
    city_id: 8,
  },
  1819: {
    data_id: 1819,
    name_uz: 'Paxtachi tumani',
    city_id: 8,
  },
  2604: {
    data_id: 2604,
    name_uz: 'Yakkasaroy tumani',
    city_id: 12,
  },
  2609: {
    data_id: 2609,
    name_uz: 'Olmazor tumani',
    city_id: 12,
  },
  2611: {
    data_id: 2611,
    name_uz: 'Bektemir tumani',
    city_id: 12,
  },
  2608: {
    data_id: 2608,
    name_uz: 'Yashnobod tumani',
    city_id: 12,
  },
  2606: {
    data_id: 2606,
    name_uz: 'Chilonzor tumani',
    city_id: 12,
  },
  2610: {
    data_id: 2610,
    name_uz: 'Uchtepa tumani',
    city_id: 12,
  },
  2602: {
    data_id: 2602,
    name_uz: 'Mirzo Ulug‘bek tumani',
    city_id: 12,
  },
  2712: {
    data_id: 2712,
    name_uz: 'O‘rtachirchiq tumani',
    city_id: 11,
  },
  2705: {
    data_id: 2705,
    name_uz: 'Yuqorichirchiq tumani',
    city_id: 11,
  },
  2715: {
    data_id: 2715,
    name_uz: 'Yangiyo‘l tumani',
    city_id: 11,
  },
  2722: {
    data_id: 2722,
    name_uz: 'Toshkent tumani',
    city_id: 11,
  },
  2721: {
    data_id: 2721,
    name_uz: 'Yangiyo‘l shahar',
    city_id: 11,
  },
  2711: {
    data_id: 2711,
    name_uz: 'Ohangaron shahar',
    city_id: 11,
  },
  2723: {
    data_id: 2723,
    name_uz: 'Nurafshon shahar',
    city_id: 11,
  },
  3012: {
    data_id: 3012,
    name_uz: 'Oltiariq tumani',
    city_id: 10,
  },
  3013: {
    data_id: 3013,
    name_uz: 'Qo‘shtepa tumani',
    city_id: 10,
  },
  2605: {
    data_id: 2605,
    name_uz: 'Shayxontohur tumani',
    city_id: 12,
  },
  2612: {
    data_id: 2612,
    name_uz: 'Yangihayot tumani',
    city_id: 12,
  },
  803: {
    data_id: 803,
    name_uz: "G'allaorol tumani",
    city_id: 14,
  },
  804: {
    data_id: 804,
    name_uz: 'Sharof Rashidov tumani',
    city_id: 14,
  },
  806: {
    data_id: 806,
    name_uz: 'Zarbdor tumani',
    city_id: 14,
  },
  808: {
    data_id: 808,
    name_uz: 'Zafarobod tumani',
    city_id: 14,
  },
  810: {
    data_id: 810,
    name_uz: 'Paxtakor tumani',
    city_id: 14,
  },
  809: {
    data_id: 809,
    name_uz: "Mirzacho'l tumani",
    city_id: 14,
  },
  811: {
    data_id: 811,
    name_uz: 'Forish tumani',
    city_id: 14,
  },
  813: {
    data_id: 813,
    name_uz: 'Yangiobod tumani',
    city_id: 14,
  },
  2216: {
    data_id: 2216,
    name_uz: 'Bandixon tumani',
    city_id: 15,
  },
  2410: {
    data_id: 2410,
    name_uz: 'Guliston shahar',
    city_id: 9,
  },
  2412: {
    data_id: 2412,
    name_uz: 'Shirin shahar',
    city_id: 9,
  },
  2413: {
    data_id: 2413,
    name_uz: 'Yangiyer shahar',
    city_id: 9,
  },
  2708: {
    data_id: 2708,
    name_uz: 'Ohangaron tumani',
    city_id: 11,
  },
  2709: {
    data_id: 2709,
    name_uz: 'Parkent tumani',
    city_id: 11,
  },
  3522: {
    data_id: 3522,
    name_uz: "Qorao'zak tumani",
    city_id: 5,
  },
  3511: {
    data_id: 3511,
    name_uz: 'Kegeyli tumani',
    city_id: 5,
  },
  3512: {
    data_id: 3512,
    name_uz: "Qo'nrg'irot tumani",
    city_id: 5,
  },
  3514: {
    data_id: 3514,
    name_uz: 'Muynoq tumani',
    city_id: 5,
  },
  3515: {
    data_id: 3515,
    name_uz: 'Nukus tumani',
    city_id: 5,
  },
  613: {
    data_id: 613,
    name_uz: 'Shofirkon tumani',
    city_id: 3,
  },
  610: {
    data_id: 610,
    name_uz: 'Qorako‘l tumani',
    city_id: 3,
  },
  614: {
    data_id: 614,
    name_uz: 'Qorovulbozor tumani',
    city_id: 3,
  },
  2406: {
    data_id: 2406,
    name_uz: 'Sayxunobod tumani',
    city_id: 9,
  },
  2407: {
    data_id: 2407,
    name_uz: 'Sirdaryo tumani',
    city_id: 9,
  },
  2409: {
    data_id: 2409,
    name_uz: 'Sardoba tumani',
    city_id: 9,
  },
  2408: {
    data_id: 2408,
    name_uz: 'Xovos tumani',
    city_id: 9,
  },
  2603: {
    data_id: 2603,
    name_uz: 'Yunusobod tumani',
    city_id: 12,
  },
  2601: {
    data_id: 2601,
    name_uz: 'Mirobod tumani',
    city_id: 12,
  },
  2716: {
    data_id: 2716,
    name_uz: 'Angren shahar',
    city_id: 11,
  },
  2717: {
    data_id: 2717,
    name_uz: 'Bekobod shahar',
    city_id: 11,
  },
  2718: {
    data_id: 2718,
    name_uz: 'Olmaliq shahar',
    city_id: 11,
  },
  2720: {
    data_id: 2720,
    name_uz: 'Chirchiq shahar',
    city_id: 11,
  },
  2701: {
    data_id: 2701,
    name_uz: 'Bekobod tumani',
    city_id: 11,
  },
  2702: {
    data_id: 2702,
    name_uz: 'Bo‘ka tumani',
    city_id: 11,
  },
  2703: {
    data_id: 2703,
    name_uz: 'Bo‘stonliq tumani',
    city_id: 11,
  },
  2706: {
    data_id: 2706,
    name_uz: 'Qibray tumani',
    city_id: 11,
  },
  2704: {
    data_id: 2704,
    name_uz: 'Zangiota tumani',
    city_id: 11,
  },
  2714: {
    data_id: 2714,
    name_uz: 'Quyichirchiq tumani',
    city_id: 11,
  },
  3004: {
    data_id: 3004,
    name_uz: 'Marg‘ilon shahar',
    city_id: 10,
  },
  3005: {
    data_id: 3005,
    name_uz: 'Farg‘ona shahar',
    city_id: 10,
  },
  3001: {
    data_id: 3001,
    name_uz: 'Quvasoy shahar',
    city_id: 10,
  },
  3003: {
    data_id: 3003,
    name_uz: 'Qo‘qon shahar',
    city_id: 10,
  },
  3007: {
    data_id: 3007,
    name_uz: 'Bog‘dod tumani',
    city_id: 10,
  },
  3006: {
    data_id: 3006,
    name_uz: 'Beshariq tumani',
    city_id: 10,
  },
  3008: {
    data_id: 3008,
    name_uz: 'Buvayda tumani',
    city_id: 10,
  },
  3009: {
    data_id: 3009,
    name_uz: 'Dang‘ara tumani',
    city_id: 10,
  },
  3010: {
    data_id: 3010,
    name_uz: 'Yozyovon tumani',
    city_id: 10,
  },
  3516: {
    data_id: 3516,
    name_uz: "Taxtako'prik tumani",
    city_id: 5,
  },
  3517: {
    data_id: 3517,
    name_uz: "To'rtko'l tumani",
    city_id: 5,
  },
  3518: {
    data_id: 3518,
    name_uz: 'Xo‘jayli tumani',
    city_id: 5,
  },
  3519: {
    data_id: 3519,
    name_uz: 'Chimboy tumani',
    city_id: 5,
  },
  3520: {
    data_id: 3520,
    name_uz: "Sho'manay tumani",
    city_id: 5,
  },
  3521: {
    data_id: 3521,
    name_uz: 'Ellikqal’a tumani',
    city_id: 5,
  },
  3504: {
    data_id: 3504,
    name_uz: 'Taxiatosh tumani',
    city_id: 5,
  },
  3510: {
    data_id: 3510,
    name_uz: "Bo'zatov tumani",
    city_id: 5,
  },
  603: {
    data_id: 603,
    name_uz: 'Kogon shahar',
    city_id: 3,
  },
  1801: {
    data_id: 1801,
    name_uz: 'Samarqand shahar',
    city_id: 8,
  },
  1808: {
    data_id: 1808,
    name_uz: 'Oqdaryo tumani',
    city_id: 8,
  },
  1809: {
    data_id: 1809,
    name_uz: 'Bulung‘ur tumani',
    city_id: 8,
  },
  1811: {
    data_id: 1811,
    name_uz: 'Jomboy tumani',
    city_id: 8,
  },
  1813: {
    data_id: 1813,
    name_uz: 'Kattaqurg‘on tumani',
    city_id: 8,
  },
  1815: {
    data_id: 1815,
    name_uz: 'Narpay tumani',
    city_id: 8,
  },
  2401: {
    data_id: 2401,
    name_uz: 'Oqoltin tumani',
    city_id: 9,
  },
  2402: {
    data_id: 2402,
    name_uz: 'Boyovut tumani',
    city_id: 9,
  },
  2403: {
    data_id: 2403,
    name_uz: 'Guliston tumani',
    city_id: 9,
  },
  2405: {
    data_id: 2405,
    name_uz: 'Mirzaobod tumani',
    city_id: 9,
  },
  2707: {
    data_id: 2707,
    name_uz: 'Oqqo‘rg‘on tumani',
    city_id: 11,
  },
  3301: {
    data_id: 3301,
    name_uz: 'Urganch shahar',
    city_id: 13,
  },
  301: {
    data_id: 301,
    name_uz: 'Andijon shaxri',
    city_id: 2,
  },
  303: {
    data_id: 303,
    name_uz: 'Xonobod shaxri',
    city_id: 2,
  },
  307: {
    data_id: 307,
    name_uz: 'Andijon tumani',
    city_id: 2,
  },
  315: {
    data_id: 315,
    name_uz: 'Asaka tumani',
    city_id: 2,
  },
  308: {
    data_id: 308,
    name_uz: 'Baliqchi tumani',
    city_id: 2,
  },
  310: {
    data_id: 310,
    name_uz: 'Buloqboshi tumani',
    city_id: 2,
  },
  311: {
    data_id: 311,
    name_uz: 'Jalaquduq tumani',
    city_id: 2,
  },
  801: {
    data_id: 801,
    name_uz: 'Arnasoy tumani',
    city_id: 14,
  },
  1015: {
    data_id: 1015,
    name_uz: 'Shahrisabz tumani',
    city_id: 4,
  },
  1006: {
    data_id: 1006,
    name_uz: 'Qamashi tumani',
    city_id: 4,
  },
  1005: {
    data_id: 1005,
    name_uz: 'Dehqonobod tumani',
    city_id: 4,
  },
  1016: {
    data_id: 1016,
    name_uz: 'Yakkabog‘ tumani',
    city_id: 4,
  },
  1419: {
    data_id: 1419,
    name_uz: 'Yangi Namangan tumani',
    city_id: 7,
  },
  1804: {
    data_id: 1804,
    name_uz: 'Tayloq tumani',
    city_id: 8,
  },
  1822: {
    data_id: 1822,
    name_uz: 'Urgut tumani',
    city_id: 8,
  },
  1812: {
    data_id: 1812,
    name_uz: 'Ishtixon tumani',
    city_id: 8,
  },
  2208: {
    data_id: 2208,
    name_uz: "Jarqo'rg'on tumani",
    city_id: 15,
  },
  2203: {
    data_id: 2203,
    name_uz: 'Angor tumani',
    city_id: 15,
  },
  312: {
    data_id: 312,
    name_uz: 'Izboskan tumani',
    city_id: 2,
  },
  313: {
    data_id: 313,
    name_uz: 'Ulugnor tumani',
    city_id: 2,
  },
  314: {
    data_id: 314,
    name_uz: 'Qo‘rg‘ontepa tumani',
    city_id: 2,
  },
  316: {
    data_id: 316,
    name_uz: 'Marxamat tumani',
    city_id: 2,
  },
  306: {
    data_id: 306,
    name_uz: 'Oltinko‘l tumani',
    city_id: 2,
  },
  318: {
    data_id: 318,
    name_uz: 'Paxtaobod tumani',
    city_id: 2,
  },
  319: {
    data_id: 319,
    name_uz: 'Xo‘jaobod tumani',
    city_id: 2,
  },
  317: {
    data_id: 317,
    name_uz: 'Shaxrixon tumani',
    city_id: 2,
  },
  2205: {
    data_id: 2205,
    name_uz: 'Boysun tumani',
    city_id: 15,
  },
  2207: {
    data_id: 2207,
    name_uz: 'Denov tumani',
    city_id: 15,
  },
  1201: {
    data_id: 1201,
    name_uz: 'Navoiy shahar',
    city_id: 6,
  },
  1213: {
    data_id: 1213,
    name_uz: "G'ozg'on shahar",
    city_id: 6,
  },
  1211: {
    data_id: 1211,
    name_uz: 'Karmana tumani',
    city_id: 6,
  },
  1208: {
    data_id: 1208,
    name_uz: 'Navbahor tumani',
    city_id: 6,
  },
  1210: {
    data_id: 1210,
    name_uz: 'Nurota tumani',
    city_id: 6,
  },
  1209: {
    data_id: 1209,
    name_uz: 'Xatirchi tumani',
    city_id: 6,
  },
  1205: {
    data_id: 1205,
    name_uz: 'Qiziltepa tumani',
    city_id: 6,
  },
  1204: {
    data_id: 1204,
    name_uz: 'Konimex tumani',
    city_id: 6,
  },
  1203: {
    data_id: 1203,
    name_uz: 'Uchquduq tumani',
    city_id: 6,
  },
  1202: {
    data_id: 1202,
    name_uz: 'Zarafshon shahar',
    city_id: 6,
  },
  1207: {
    data_id: 1207,
    name_uz: 'Tomdi tumani',
    city_id: 6,
  },
  1401: {
    data_id: 1401,
    name_uz: 'Namangan shahar',
    city_id: 7,
  },
  1407: {
    data_id: 1407,
    name_uz: 'Mingbuloq tumani',
    city_id: 7,
  },
  1410: {
    data_id: 1410,
    name_uz: 'Norin tumani',
    city_id: 7,
  },
  1412: {
    data_id: 1412,
    name_uz: 'To‘raqo‘rg‘on tumani',
    city_id: 7,
  },
  1413: {
    data_id: 1413,
    name_uz: 'Uychi tumani',
    city_id: 7,
  },
  1415: {
    data_id: 1415,
    name_uz: 'Chortoq tumani',
    city_id: 7,
  },
  3501: {
    data_id: 3501,
    name_uz: 'Nukus shaxri',
    city_id: 5,
  },
  3508: {
    data_id: 3508,
    name_uz: 'Amudarya tumani',
    city_id: 5,
  },
  3509: {
    data_id: 3509,
    name_uz: 'Beruniy tumani',
    city_id: 5,
  },
  3513: {
    data_id: 3513,
    name_uz: 'Qonliko‘l tumani',
    city_id: 5,
  },
  2210: {
    data_id: 2210,
    name_uz: 'Qiziriq tumani',
    city_id: 15,
  },
  2209: {
    data_id: 2209,
    name_uz: "Qumqo'rg'on tumani",
    city_id: 15,
  },
  2206: {
    data_id: 2206,
    name_uz: 'Muzrabot tumani',
    city_id: 15,
  },
  2204: {
    data_id: 2204,
    name_uz: 'Oltinsoy tumani',
    city_id: 15,
  },
  2211: {
    data_id: 2211,
    name_uz: 'Sariosiyo tumani',
    city_id: 15,
  },
  2212: {
    data_id: 2212,
    name_uz: 'Termiz tumani',
    city_id: 15,
  },
  2201: {
    data_id: 2201,
    name_uz: 'Termiz shahar',
    city_id: 15,
  },
  3311: {
    data_id: 3311,
    name_uz: 'Bog‘ot tumani',
    city_id: 13,
  },
  3307: {
    data_id: 3307,
    name_uz: 'Gurlan tumani',
    city_id: 13,
  },
  3306: {
    data_id: 3306,
    name_uz: 'Xazorasp tumani',
    city_id: 13,
  },
  3305: {
    data_id: 3305,
    name_uz: 'Xiva tumani',
    city_id: 13,
  },
  3312: {
    data_id: 3312,
    name_uz: 'Honqa tumani',
    city_id: 13,
  },
  3304: {
    data_id: 3304,
    name_uz: 'Urganch tumani',
    city_id: 13,
  },
  3310: {
    data_id: 3310,
    name_uz: 'Qo‘shko‘pir tumani',
    city_id: 13,
  },
  2215: {
    data_id: 2215,
    name_uz: 'Uzun tumani',
    city_id: 15,
  },
  2213: {
    data_id: 2213,
    name_uz: 'Sherobod tumani',
    city_id: 15,
  },
  2214: {
    data_id: 2214,
    name_uz: "Sho'rchi tumani",
    city_id: 15,
  },
  1806: {
    data_id: 1806,
    name_uz: 'Kattaqurg‘on shahar',
    city_id: 8,
  },
  1409: {
    data_id: 1409,
    name_uz: 'Namangan tumani',
    city_id: 7,
  },
  1414: {
    data_id: 1414,
    name_uz: 'Uchqo‘rg‘on tumani',
    city_id: 7,
  },
  1408: {
    data_id: 1408,
    name_uz: 'Kosonsoy tumani',
    city_id: 7,
  },
  1418: {
    data_id: 1418,
    name_uz: 'Davlatobod tumani',
    city_id: 7,
  },
  1411: {
    data_id: 1411,
    name_uz: 'Pop tumani',
    city_id: 7,
  },
  2713: {
    data_id: 2713,
    name_uz: 'Chinoz tumani',
    city_id: 11,
  },
  601: {
    data_id: 601,
    name_uz: 'Buxoro shahar',
    city_id: 3,
  },
  605: {
    data_id: 605,
    name_uz: 'Buxoro tumani',
    city_id: 3,
  },
  606: {
    data_id: 606,
    name_uz: 'Vobkent tumani',
    city_id: 3,
  },
  607: {
    data_id: 607,
    name_uz: 'G‘ijduvon tumani',
    city_id: 3,
  },
  608: {
    data_id: 608,
    name_uz: 'Jondor tumani',
    city_id: 3,
  },
  609: {
    data_id: 609,
    name_uz: 'Kogon tumani',
    city_id: 3,
  },
  604: {
    data_id: 604,
    name_uz: 'Olot tumani',
    city_id: 3,
  },
  611: {
    data_id: 611,
    name_uz: 'Peshku tumani',
    city_id: 3,
  },
  612: {
    data_id: 612,
    name_uz: 'Romitan tumani',
    city_id: 3,
  },
  1001: {
    data_id: 1001,
    name_uz: 'Qarshi shahar',
    city_id: 4,
  },
  1004: {
    data_id: 1004,
    name_uz: 'G‘uzor tumani',
    city_id: 4,
  },
  1007: {
    data_id: 1007,
    name_uz: 'Qarshi tumani',
    city_id: 4,
  },
  1012: {
    data_id: 1012,
    name_uz: 'Kasbi tumani',
    city_id: 4,
  },
  1008: {
    data_id: 1008,
    name_uz: 'Koson tumani',
    city_id: 4,
  },
  1009: {
    data_id: 1009,
    name_uz: 'Kitob tumani',
    city_id: 4,
  },
  1017: {
    data_id: 1017,
    name_uz: 'Mirishkor tumani',
    city_id: 4,
  },
  1010: {
    data_id: 1010,
    name_uz: 'Muborak tumani',
    city_id: 4,
  },
  1011: {
    data_id: 1011,
    name_uz: 'Nishon tumani',
    city_id: 4,
  },
  1014: {
    data_id: 1014,
    name_uz: 'Chiroqchi tumani',
    city_id: 4,
  },
  3014: {
    data_id: 3014,
    name_uz: 'Rishton tumani',
    city_id: 10,
  },
  3015: {
    data_id: 3015,
    name_uz: 'So‘x tumani',
    city_id: 10,
  },
  3016: {
    data_id: 3016,
    name_uz: 'Toshloq tumani',
    city_id: 10,
  },
  3018: {
    data_id: 3018,
    name_uz: 'Uchko‘prik tumani',
    city_id: 10,
  },
  3019: {
    data_id: 3019,
    name_uz: 'Farg‘ona tumani',
    city_id: 10,
  },
  3020: {
    data_id: 3020,
    name_uz: 'Furqat tumani',
    city_id: 10,
  },
  3017: {
    data_id: 3017,
    name_uz: 'O‘zbekiston tumani',
    city_id: 10,
  },
  3011: {
    data_id: 3011,
    name_uz: 'Quva tumani',
    city_id: 10,
  },
  3308: {
    data_id: 3308,
    name_uz: 'Shovot tumani',
    city_id: 13,
  },
  3309: {
    data_id: 3309,
    name_uz: 'Yangiariq tumani',
    city_id: 13,
  },
  3313: {
    data_id: 3313,
    name_uz: 'Yangibozor tumani',
    city_id: 13,
  },
  3303: {
    data_id: 3303,
    name_uz: 'Xiva shahar',
    city_id: 13,
  },
  3314: {
    data_id: 3314,
    name_uz: "Tuproqqal'a tumani",
    city_id: 13,
  },
  812: {
    data_id: 812,
    name_uz: 'Jizzax shahar',
    city_id: 14,
  },
  802: {
    data_id: 802,
    name_uz: 'Baxmal tumani',
    city_id: 14,
  },
  805: {
    data_id: 805,
    name_uz: "Do'stlik tumani",
    city_id: 14,
  },
  1002: {
    data_id: 1002,
    name_uz: 'Shahrisabz shahar',
    city_id: 4,
  },
  1416: {
    data_id: 1416,
    name_uz: 'Chust tumani',
    city_id: 7,
  },
  1417: {
    data_id: 1417,
    name_uz: 'Yangiqo‘rg‘on tumani',
    city_id: 7,
  },
  1820: {
    data_id: 1820,
    name_uz: 'Samarqand tumani',
    city_id: 8,
  },
  807: {
    data_id: 807,
    name_uz: 'Zomin tumani',
    city_id: 14,
  },
}
